import { render, staticRenderFns } from "./QrDialog.vue?vue&type=template&id=70f0318c&"
import script from "./QrDialog.vue?vue&type=script&lang=js&"
export * from "./QrDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports